<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-sunset`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M36.556 17.122C34.8 9.602 28.055 4 20 4 10.611 4 3 11.611 3 21c0 2.893.722 5.617 1.997 8.001h4.756A12.944 12.944 0 017 21c0-7.18 5.82-13 13-13s13 5.82 13 13h2l.225.004a6 6 0 015.433 7.997H44.8c.131-.647.2-1.316.2-2.001 0-4.994-3.66-9.133-8.444-9.878zM43 33a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1v-2a1 1 0 011-1h38zm0 8a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1v-2a1 1 0 011-1h38z"/></svg>
</template>
<script>

export default {
  name: 'IconSunset',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
